import { Component, DestroyRef, HostListener, inject, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ng2-cookies/cookie';
import { LanguageService } from './services/language.service';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { RouterExtService } from './services/router-ext.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AppBootstrapErrorService } from './services/app-bootstrap-error.service';
import { CookieBannerComponent } from './standalone-core/features';

@Component({
  selector: 'sma-web-root',
  template: `
    <sma-web-cookie-banner />
    <router-outlet />
  `,
  imports: [CookieBannerComponent, RouterOutlet],
})
export class AppComponent implements OnInit {
  private readonly destroyRef: DestroyRef = inject(DestroyRef);
  private readonly router: Router = inject(Router);
  private readonly appBootstrapErrorService: AppBootstrapErrorService = inject(AppBootstrapErrorService);

  @HostListener('document:dragenter', ['$event'])
  onDragEnterWindow(event: DragEvent): void {
    this.dragEvent(event);
  }

  @HostListener('document:dragover', ['$event'])
  onDragoverWindow(event: DragEvent): void {
    this.dragEvent(event);
  }

  @HostListener('document:drop', ['$event'])
  onDropWindow(event: DragEvent): void {
    this.dragEvent(event);
  }

  constructor() {
    const cookieService = inject(CookieService);
    const translate = inject(TranslateService);
    const languageservice = inject(LanguageService);
    const routerExtService = inject(RouterExtService);

    // init routerExtService for whole page. Don't delete this line.
    routerExtService.init();
    // this language will be used as a fallback when a translation isn't found in the current language
    translate.setDefaultLang('en');
    // use the lang from the browser, if the lang isn't available, it will use the current loader to get them
    const langCode = cookieService.check('sma-web-lang-code') ? cookieService.get('sma-web-lang-code') : navigator.language.slice(0, 2);
    languageservice.activateLanguage(langCode);
  }

  async ngOnInit(): Promise<void> {
    if (this.appBootstrapErrorService.hasError()) {
      void this.router.navigateByUrl('/service-unavailable');
      return;
    }

    this.router.events
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(evt => {
        if (!(evt instanceof NavigationEnd)) {
          return;
        }
        window.scrollTo(0, 0);
      });
  }

  dragEvent(event: DragEvent): void {
    if ((event.target as Element).id !== 'dropzone') {
      event.preventDefault();
      event.dataTransfer.effectAllowed = 'none';
      event.dataTransfer.dropEffect = 'none';
    }
  }
}
